export const scheduleCalendarBusinessFreeTour = {
  tourKey: 'schedule_calendar_business_free',
  conditions: {
    orgTypes: ['business'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: ['free'],
  },
  steps: [
    {
      target: '[data-tour="schedule-view-filters"]',
      title: 'tours.schedule-calendar-business-free.view-filters.title',
      content: 'tours.schedule-calendar-business-free.view-filters.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="schedule-skip-to-date"]',
      title: 'tours.schedule-calendar-business-free.skip-to-date.title',
      content: 'tours.schedule-calendar-business-free.skip-to-date.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="schedule-navigation"]',
      title: 'tours.schedule-calendar-business-free.navigation.title',
      content: 'tours.schedule-calendar-business-free.navigation.content',
      placement: 'left',
    },
  ],
};
